<!--客户流失列表-->
<template>
    <div class="customerList-module">
        <div class="store-box flex-start flex-y-center" v-if="regionPostId.includes(postId)">
            <div @click="openRegionPopup" class="region-name-box flex-row flex-between flex-y-center">
                <div class="name-txt">{{checkedRegion.name}}</div>
                <img class="store-arrow" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/node/home-right-arrow.png"
                    alt="">
            </div>
            <div v-if="checkedStore.id != -1" @click="openRegionStorePopup"
                class="store-name-box flex-row flex-between flex-y-center">
                <div class="name-txt">{{checkedStore.name}}</div>
                <img class="store-arrow" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/node/home-right-arrow.png"
                    alt="">
            </div>
        </div>
        <form action="/">
            <van-search class="search-button" v-model="searchStr" @search="onSearch" @clear="selClear" placeholder="搜索姓名/手机/会员卡号"
                left-icon="https://staticwecom.beautyfarm.com.cn/wecom-workbench/2022-07-07/search.png">
            </van-search>
        </form>
        <div class="select-box flex flex-y-center flex-start">
            <div v-if="postId == 1||postId == '1472787652026765367'" class="select-item flex flex-between flex-y-center ml-20"
                @click="selectEmployeePopup">
                <div class="select-tit">{{ checkedEmployee && checkedEmployee.name}}</div>
                <van-icon name="play" class="select-arrow" />
            </div>
            <div class="select-item  flex-start flex-y-center ml-20" @click="selectReasonPopup">
                <div class="select-tit">{{ checkedLeave && checkedLeave.name}}</div>
                <van-icon name="play" class="select-arrow" />
            </div>
            <div class="select-item  flex-start flex-y-center ml-20" @click="selectTimePopup">
                <div class="select-tit">{{ dateTxt }}</div>
                <van-icon name="play" class="select-arrow" />
            </div>
        </div>
        <div class="update-time">
            数据更新至{{ updateTime }}
        </div>
        <div class="list-box">
            <van-pull-refresh v-model="refreshing" @refresh="onRefresh" success-text="刷新成功">
                <!-- 下拉刷新 -->
                <van-list v-model="loading" :finished="finished" :loading="loading" finished-text="没有更多了" @load="onLoad"
                    :offset="20" :immediate-check="false">
                    <div class="customer-list flex-col" v-for="(item, index) in customerList" :key="index"
                        @click="toDetail(item.id)">
                        <div class="flex-row">
                            <!-- <div class="img-box"> -->
                            <img class="customer-head-portrait" referrerpolicy="no-referrer" alt=""
                                :src="item.avatar ? item.avatar : 'https://staticwecom.beautyfarm.com.cn/wecom-workbench/2022-07-06/headPortrait.png'" />
                            <!-- </div> -->
                            <div class="customer-info flex-1">
                                <div class="flex-y-center">
                                    <div class="customer-name">{{ item.custName }}
                                    </div>
                                    <img class="card-image" v-if="item.levelCode" referrerpolicy="no-referrer" alt=""
                                        :src="item.levelCodeImg" />
                                </div>
                                <div class="churn-time">流失时间：{{ item.leaveDate }}</div>
                            </div>
                            <img class="arrow_right" referrerpolicy="no-referrer" alt=""
                                src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/node/arrow_right.png" />
                        </div>
                        <div class="customer-remark flex-between flex-y-center">
                            <div class="flex-between flex-y-center">
                                <span class="sale-name">专属：</span>
                                <span class="sale-number">{{ item.newExclusive }}</span>
                            </div>
                            <div class="flex-between flex-y-center">
                                <span class="sale-name">流失原因：</span>
                                <span class="sale-number">{{ item.reason }}</span>
                            </div>
                        </div>
                    </div>
                </van-list>
            </van-pull-refresh>
            <van-popup v-model="showEmployeePopup" round position="bottom" closeable class="popup">
                <picker title="全部员工" @handle="checkedEmployee" v-model="checkedEmployee" :list="employeeList"
                    @change="onEmployeeChange"></picker>
            </van-popup>
            <van-popup v-model="showReasonPopup" round position="bottom" closeable class="popup">
                <picker title="流失原因" @handle="checkedLeave" v-model="checkedLeave" :list="leaveList" @change="onLeaveChange">
                </picker>
            </van-popup>
            <van-popup v-model="showTimePopup" round position="bottom" closeable class="popup">
                <date-picker v-model="dateType" @submit="handleDate" :pickerType="pickerType"></date-picker>
            </van-popup>
            <!-- 区经区总 切换区域 -->
            <van-popup v-model="showRegionPopup" round position="bottom" closeable class="popup">
                <picker title="选择区域" v-model="checkedRegion" :list="regionList" @change="onRegionChange"></picker>
            </van-popup>
            <!-- 区经区总 切换门店 -->
            <van-popup v-model="showRegionStorePopup" round position="bottom" closeable class="popup">
                <picker title="选择门店" v-model="checkedStore" :list="regionStoreList" @change="onRegionStoreChange"></picker>
            </van-popup>
        </div>
    </div>
</template>

<script>
import request from "@/utils/request";
import { timestampToYestoday } from '@/utils/validate';
import DatePicker, { getDateText, getFormatTime, PICKER_TYPE } from '@/components/DatePicker';
import Picker from '@/components/Picker';
import { Search, Toast } from "vant";
import { getCookie } from '@/utils'
import { keepAliveAfterHandler } from "@/router/router";
import { getUserLogin, getRegionStoreList, saveRegionStore } from '@/api/home'
import { mapState } from 'vuex'


export default {
    name: "customerChurn",
    inject: ['reload'],
    components: {
        [Search.name]: Search, DatePicker, Picker
    },
    computed: {
        dateTxt() {
            return getDateText(this.dateType, this.beginMonth, this.endMonth, this.pickerType)
        },
        ...mapState({
            regionPostId: (state) => {
                return state.user.permissions.regionPostId
            },// 区经区总id
        }),
    },
    beforeRouteLeave(to, from, next) {
        keepAliveAfterHandler.call(this, to, from)
        next()
    },
    data() {
        return {
            pickerType: PICKER_TYPE.MONTH,// 日期类型
            dateType: '2', // 日期
            beginMonth: '', // 开始日期
            endMonth: '', // 结束日期
            updateTime: timestampToYestoday(),   //更新时间
            showTimePopup: false,//选择时间弹窗
            showEmployeePopup: false, //选择员工弹窗
            showReasonPopup: false, //选择流失原因
            searchStr: '',  // 搜索条件
            page: 1,       //当前页
            customerList: [],    //流失顾客列表
            loading: false,    //加载
            finished: false,    //结束加载
            refreshing: false,   //刷新
            limit: 10,       //每页多少条
            employeeList: [],    //员工列表
            checkedEmployee: { id: 0, name: '全部员工' },
            leaveList: [],    //流失列表
            checkedLeave: { id: 0, name: '流失原因' },
            postId: 0, // 岗位
            showRegionPopup: false,
            showRegionStorePopup: false,
            regionStoreList: [],//区域门店列表
            regionList: [],//区域列表
            checkedRegion: { id: -1, name: '' },//所选区域
            checkedStore: {  //所选门店
                name: '',
                id: -1,
            },
        };
    },
    mounted() {
        this.postId = getCookie('postId') || localStorage.getItem('postId');
        this.onReload()
    },
    methods: {
        onReload() {
            this.page = 1
            this.customerList = [];
            // 获取当前登陆人所记录的区域门店信息
            getUserLogin().then((res) => {
                if (this.regionPostId.includes(this.postId)) {
                    this.checkedRegion.name = res.data.region?.storeName // 当前区域
                    this.checkedRegion.id = res.data.region?.id
                    if (res.data.store) {
                        this.checkedStore.name = res.data.store.storeName //当前门店
                        this.checkedStore.id = res.data.store.id
                        // 门店列表
                        let params = {
                            id: this.checkedRegion.id
                        }
                        getRegionStoreList(params).then((res) => {
                            this.regionStoreList = res.data
                        })
                    }
                    // 区域列表
                    getRegionStoreList().then((res) => {
                        this.regionList = res.data
                    })
                    // 如果当前没有选择门店记录，则进入大区页面
                    if (this.checkedStore.id == 0 || this.checkedStore.id == -1) {
                        console.log(1);

                        this.$router.replace({
                            name: "customerChurnRegionPage"
                        });
                    }
                }
                this.getEmpList();
                this.getLeaveList();
                this.onLoad();
            })
        },
        onLoad() {
            this.loading = true
            const beginDate = getFormatTime(this.beginMonth, this.pickerType)
            const endDate = getFormatTime(this.endMonth, this.pickerType)
            let params = {
                name: this.searchStr,
                cause: this.checkedLeave.id,
                empNo: this.checkedEmployee.id,
                dateType: this.dateType,
                beginMonth: beginDate,
                endMonth: endDate,
                page: this.page,
            }
            if (this.regionPostId.includes(this.postId)) {
                params.id = this.checkedRegion.id
                params.storeId = this.checkedStore.id
            }
            request({
                url: "/custleavelog/list",
                method: "get",
                params: params
            })
                .then((res) => {
                    this.customerList = this.page == 1 ? res.data : this.customerList.concat(res.data);
                    this.page += 1;
                    if (res.data.length < this.limit) {
                        this.finished = true;
                    }
                }).catch((error) => {
                    this.finished = true
                    Toast({ position: 'top', message: error ?? '' })
                }).finally(() => {
                    this.loading = false;
                    this.refreshing = false
                });
        },
        // 获取员工列表
        getEmpList() {
            request({
                url: "/workEmployee/getEmployeeList",
                method: "get",
            })
                .then((res) => {
                    this.employeeList = res.data
                    this.checkedEmployee = this.employeeList[0] //默认全部
                    // this.onLoad();
                }).catch((error) => {
                    Toast({ position: 'top', message: error ?? '' })
                })
        },
        // 获取流失类型列表
        getLeaveList() {
            request({
                url: "/custleavelog/type",
                method: "get",
            })
                .then((res) => {
                    this.leaveList = res.data
                    this.checkedLeave = this.leaveList[0] //默认全部
                }).catch((error) => {
                    Toast({ position: 'top', message: error ?? '' })
                })
        },
        //搜索
        onSearch() {
            this.page = 1
            this.onLoad();
        },
        onRefresh() {
            this.page = 1
            // 清空列表数据
            this.finished = false;
            // 重新加载数据
            // 将 loading 设置为 true，表示处于加载状态
            this.loading = true;
            this.customerList = [];
            this.refreshing = false;
            this.onLoad();
        },
        //详情页
        toDetail(id) {
            this.$router.push({ name: "customerChurnDetail", query: { id: id } });
        },
        //清除搜索
        selClear() {
            this.searchStr = "";
            this.page = 1
            this.onLoad();
        },
        //员工选择
        selectEmployeePopup() {
            this.showEmployeePopup = true;
        },
        //流失原因选择
        selectReasonPopup() {
            this.showReasonPopup = true;
        },
        // 时间弹窗
        selectTimePopup() {
            this.showTimePopup = true
        },

        //员工筛选
        onEmployeeChange(data) {
            this.checkedEmployee = data
            this.showEmployeePopup = false
            this.onRefresh();
        },
        //流失原因筛选
        onLeaveChange(data) {
            this.checkedLeave = data
            this.showReasonPopup = false
            this.onRefresh();
        },

        // 时间确定
        handleDate(id, begin, end) {
            this.showTimePopup = false
            this.dateType = id
            if (!id) {
                this.beginMonth = begin
                this.endMonth = end
            } else {
                this.beginMonth = ''
                this.endMonth = ''
            }
            this.onRefresh();
        },
        // 筛选区域门店相关
        openRegionPopup() {
            this.showRegionPopup = true
        },
        onRegionChange(data) {
            this.checkedRegion = data
            this.showRegionPopup = false
            this.$nextTick(() => {
                // 提交所选区域记录 storeid 覆盖为0给后端判断是区域变更
                this.checkedStore.id = 0
                let params = {
                    id: this.checkedRegion.id,
                    storeId: this.checkedStore.id
                }
                saveRegionStore(params).then((res) => {
                    console.log(2222);
                    console.log(this.reload);
                    this.onReload()
                })
            })
        },
        openRegionStorePopup() {
            this.showRegionStorePopup = true
        },
        onRegionStoreChange(data) {
            this.checkedStore = data
            this.showRegionStorePopup = false
            let params = {
                id: this.checkedRegion.id,
                storeId: this.checkedStore.id
            }
            saveRegionStore(params).then(() => {
                if (data.id == 0 || data.id == -1) {
                    this.$router.replace({
                        name: "customerChurnRegionPage"
                    });
                } else {
                    this.onReload();
                }
            })
        },

    },
};
</script>

<style scoped lang="less">
::-webkit-scrollbar {
    display: none;
}

.ml-20 {
    margin-right: 50px;
}

.update-time {
    height: 37px;
    font-size: 26px;
    color: #a0acb5;
    line-height: 37px;
    margin: 40px 0 30px 30px;
}

.van-pull-refresh {
    min-height: 100%;
}

.list-box {
    width: 100%;
    height: calc(100vh - 277px);
    justify-content: space-between;
    margin: 0 auto 0;
    position: relative;
    z-index: 1;
    overflow-y: auto;
    padding: 0 30px 250px 30px;
}

.customer-list {
    width: 690px;
    height: 200px;
    background: #fafafe;
    border-radius: 20px;
    margin-bottom: 20px;
    padding: 20px;
}

.customer-head-portrait {
    width: 90px;
    height: 90px;
    border-radius: 45px;
    margin-right: 20px;
}

.customer-name {
    min-width: 60px;
    height: 42px;
    font-size: 30px;
    color: #35434c;
    line-height: 42px;
    font-weight: 700;
}

.churn-time {
    height: 37px;
    font-size: 26px;
    color: #a0acb5;
    line-height: 37px;
    margin-top: 11px;
}

.nursing-edit-box {
    margin: 37px 0 0 163px;
}

.arrow_box {
    margin: -10px 30px 0 auto;
}

.arrow_right {
    width: 15px;
    height: 26px;
    margin-top: 10px;
}

.card-image {
    height: 34px;
    width: 90px;
    margin: 0 0 0 10px;
}

.customer-head-portrait {
    width: 90px;
    height: 90px;
    border-radius: 45px;
}

.customer-remark {
    margin: 0 160px 0 0;
}

.exclusive {
    height: 40px;
    font-size: 28px;
    color: #a0acb5;
    line-height: 40px;
    margin-top: 30px;
}

.exclusive-name {
    height: 45px;
    font-size: 28px;
    color: #35434c;
    line-height: 45px;
    margin-top: 28px;
    min-width: 40px;
    font-weight: 700;
}

.sale-name {
    height: 40px;
    font-size: 28px;
    color: #a0acb5;
    line-height: 40px;
    margin-top: 30px;
}

.sale-number {
    height: 45px;
    font-size: 28px;
    color: #35434c;
    line-height: 45px;
    margin-top: 28px;
    min-width: 40px;
    font-weight: 700;
}

.loss {
    min-width: 140px;
    height: 40px;
    font-size: 28px;
    color: #a0acb5;
    line-height: 40px;
    margin: 30px 0 0 84px;
}

.loss-reasons {
    height: 40px;
    font-size: 28px;
    color: #35434c;
    line-height: 40px;
    margin-top: 30px;
    font-weight: 700;
}

.select-box {
    margin-left: 30px;
    .select-tit {
        font-size: 28px;
        color: #35434c;
    }

    .select-arrow {
        transform: rotate(90deg);
        font-size: 24px;
        margin-left: 10px;
    }
}
.store-box {
    padding: 30px 30px;
    padding-bottom: 0;
    background-color: #fff;
    .store-arrow {
        width: 16px;
        height: 26px;
        margin-left: 8px;
        margin-top: 3px;
    }
    .region-name-box {
        min-width: 239px;
        height: 58px;
        background: #f5f5f5;
        border-radius: 35px;
        margin-right: 10px;
        padding: 10px 15px 11px 16px;
    }
    .store-name-box {
        min-width: 187px;
        height: 58px;
        background: #f5f5f5;
        border-radius: 35px;
        padding: 10px 15px 11px 16px;
    }
    .name-txt {
        color: #66757f;
        font-size: 26px;
    }
}
:deep(.van-search) {
    padding: 30px 30px 30px 30px;
}

:deep(.van-icon__image) {
    height: 28px;
    display: inline-block;
}

:deep(.van-field__control) {
    font-size: 28px !important;
}

:deep(.van-field__left-icon) {
    color: #c8c9cc !important;
    padding: 3px 20px 0 0 !important;
    margin-right: 0 !important;
}
</style>

